import { Nullable } from 'constants/types'
import { AriaAttr } from 'constants/enums'

/**
 * reverse aria-expanded attribute on element
 * @param el
 */
export const ToggleAriaExpanded = (el: Nullable<Element>): void => {
    if (!el) {
        return
    }
    if (el.getAttribute(AriaAttr.EXPANDED) == 'true') {
        el.setAttribute(AriaAttr.EXPANDED, 'false')
    } else {
        el.setAttribute(AriaAttr.EXPANDED, 'true')
    }
}

/**
 * set aria-expanded attribute on element to given string boolean
 * @param el
 * @param value true or false
 */
export const SetAriaExpanded = (
    el: Nullable<Element>,
    value: 'true' | 'false'
): void => {
    if (!el) {
        return
    }
    el.setAttribute(AriaAttr.EXPANDED, value)
}

export const toggleAreaHidden = (
    el: Nullable<HTMLElement>,
    hidden?: boolean
): void => {
    if (!el) {
        return
    }
    if (hidden === true) {
        el.setAttribute(AriaAttr.HIDDEN, 'true')
        return
    }

    if (hidden === false) {
        el.removeAttribute(AriaAttr.HIDDEN)
        return
    }

    el.toggleAttribute(AriaAttr.HIDDEN)
}
